"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/context/AuthContext";
interface AuthGuardModalProps {
  isOpen: boolean;
  onClose: () => void;
  redirectTo?: string;
}
export default function AuthGuardModal(t0) {
  const $ = _c(12);
  const {
    isOpen,
    onClose
  } = t0;
  const {
    signInWithGoogle
  } = useAuth();
  if (!isOpen) {
    return null;
  }
  let t1;
  if ($[0] !== onClose || $[1] !== signInWithGoogle) {
    t1 = async () => {
      ;
      try {
        await signInWithGoogle();
        onClose();
      } catch (t2) {
        const error = t2;
        console.error("Login failed", error);
      }
    };
    $[0] = onClose;
    $[1] = signInWithGoogle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSignIn = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-center mb-6"><div className="w-16 h-16 bg-blue-50 dark:bg-blue-900/20 rounded-full flex items-center justify-center mx-auto mb-4"><span className="text-3xl">🔒</span></div><h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Authentication Required</h2><p className="text-gray-500 dark:text-gray-400 text-sm">Please sign in to access the Dashboard and Editor features.</p></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" /><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" /><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" /><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" /></svg>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleSignIn) {
    t4 = <button onClick={handleSignIn} className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors font-medium">{t3}Sign in with Google</button>;
    $[5] = handleSignIn;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClose) {
    t5 = <button onClick={onClose} className="w-full px-4 py-3 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-slate-800 rounded-xl hover:bg-gray-200 dark:hover:bg-slate-700 transition-colors font-medium text-sm">Cancel</button>;
    $[7] = onClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-in fade-in duration-200"><div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl max-w-sm w-full p-6 border border-gray-100 dark:border-slate-800 transform transition-all scale-100">{t2}<div className="space-y-3">{t4}{t5}</div></div></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}